import { Box, Button, Tab, Tabs } from "@mui/material"
import React, { useState } from "react"
import { NexDrawer } from "../../components/Drawer/Drawer"
import { FlightlineEventReview, ReviewDrawerTab } from "../../models/MissionReview"
import { canSplitReview } from "../../utils/MissionReviewUtils"
import { useMissionReviewStore } from "../../zstore/MissionReviewStore"
import { FlightlineEventReviewTable } from "./FlightlineEventReviewTable"
import { ReviewEventDrawer } from "./ReviewEventDrawer"

export const MissionReviewTableAndDrawer = () => {
    // Mission Review Store
    const setFlightLineReviews = useMissionReviewStore((state) => state.setFlightLineReviews)
    const setCurrentPartialLines = useMissionReviewStore((state) => state.setCurrentPartialLines)
    const currentPartialLines = useMissionReviewStore((state) => state.currentPartialLines) ?? []
    const savePartialLinesToMissionReview = useMissionReviewStore((state) => state.savePartialLinesToMissionReview)

    const [tab, setTab] = useState(ReviewDrawerTab.DETAILS)

    const firstReview = currentPartialLines[0]
    const canSplit = firstReview && canSplitReview(firstReview)

    const handleChange = (_: React.SyntheticEvent, newValue: ReviewDrawerTab) => {
        setTab(newValue)
    }

    const updateRows = (rows: FlightlineEventReview[]) => setFlightLineReviews(rows)

    const handleOpenDrawerDetails = (rowId: number, selectedTab: ReviewDrawerTab) => {
        setCurrentPartialLines(rowId)
        setTab(selectedTab)
    }

    return (
        <>
            <FlightlineEventReviewTable updateRows={updateRows} handleOpenDrawerDetails={handleOpenDrawerDetails} />
            <NexDrawer
                title={`Line Event ${firstReview ? firstReview.flightplan_name_short_label : ""}`}
                open={!!currentPartialLines?.length}
                onClose={() => setCurrentPartialLines()}
                titleActions={
                    canSplit && (
                        <Tabs value={tab} onChange={handleChange} sx={{ pt: 2 }}>
                            <Tab label={"Split Flightline Event"} value={ReviewDrawerTab.SPLIT} />
                            <Tab label={"Flightline Details"} value={ReviewDrawerTab.DETAILS} />
                        </Tabs>
                    )
                }
                drawerActions={
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Button color="info" onClick={() => setCurrentPartialLines()}>
                            {canSplit ? "Cancel" : "Close"}
                        </Button>
                        {canSplit && (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={savePartialLinesToMissionReview}
                                type={"submit"}
                            >
                                Update Review Table
                            </Button>
                        )}
                    </Box>
                }
                sx={{ overflowY: "auto" }}
            >
                <ReviewEventDrawer tab={tab} />
            </NexDrawer>
        </>
    )
}
